import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AddCompanyDetails = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [website, setWebsite] = useState();
  const [address, setAddress] = useState();
  const [emergencyContact, setEergencyContact] = useState();
  const [gstin, setGstin] = useState();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();

  const handleAddCompany = () => {
    navigate("/add-company-details");
  };

  const handleViewAllCompany = () => {
    navigate("/all-company-details");
  };
  const payload = {
    name,
    email,
    phone,
    website,
    address,
    emergencyContact,
    gstin,
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${API_BASE_URL}/admin/company`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
        alert("Company Detail added successfully.");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while adding detail.");
      });
  };
  return (
    <>
      <div id="add-subject-inner-wrapper">
        <div className="superheader">
          <div className="subjectHeaderdiv">
            <h5>Company Details</h5>
            <div className="subjectdiv2">
              <button className="handleNewSubject" onClick={handleAddCompany}>
                + Add Company
              </button>
              <button className="allSubjects" onClick={handleViewAllCompany}>
                All Company
              </button>
            </div>
          </div>

          <div className="form-sub-container mt-4" id="form">
            <h4 className="subject-detail">Subject Details</h4>
            <form
              className="subject-detail-form"
              encType="multipart/form-data"
              onSubmit={handleSubmit}
            >
              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Name</label>
                </div>
                <input
                  type="text"
                  placeholder="Enter Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Email</label>
                </div>
                <input
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Phone</label>
                </div>
                <input
                  type="text"
                  placeholder="Enter Phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Website</label>
                </div>
                <input
                  type="text"
                  placeholder="Enter Website"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Address</label>
                </div>
                <input
                  type="text"
                  placeholder="Enter Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Emergency Contact</label>
                </div>
                <input
                  type="text"
                  placeholder="Enter Address"
                  value={emergencyContact}
                  onChange={(e) => setEergencyContact(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Enter GST</label>
                </div>
                <input
                  type="text"
                  placeholder="Enter gst"
                  value={gstin}
                  onChange={(e) => setGstin(e.target.value)}
                  required
                />
              </div>

              <div className="school-subj-form-btns">
                <button
                  className="btn-search"
                  type="submit"
                  // onClick={handleSubmit}
                >
                  Save
                </button>
                <button className="btn-cancel">Cancel</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCompanyDetails;
